import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useReportRuns} from '../hooks/useReportRuns';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useReportRuns();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
